<template>
  <v-app light v-scroll="onScroll">

    <v-layout column align-center justify-center 
      style="z-index: 2; position: absolute; width: 100vw; height: 100vh;">
      <h2 class="white--text">J. Hermosilla</h2>
      <h4 class="white--text bold--text pa-2" style="background: rgba(0,0,0,0.5)">GIS & Web Mapping!</h4>
    </v-layout>

    <div id="banner-welcome" style="width: 100vw; height: 100vh">
      <v-parallax style="height: 100vh" jumbotron src="/static/img/paisaje.jpg">
      </v-parallax>
    </div>

    <v-card color="grey lighten-5 primary" flat style="z-index: 2;">

      <v-layout row>
        <v-flex xs10 offset-xs1>
          <v-scale-transition>

            <v-card class="card--flex-toolbar">
              <v-toolbar card color="white" prominent>
                <v-toolbar-title class="body-2 grey--text">

                  <v-avatar
                    size="48px"
                    class="grey lighten-4"
                  >
                    <img src="/static/img/joseahr.jpg" alt="avatar">
                  </v-avatar>

                  <span>Jose Ángel Hermosilla Rodrigo</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                
              </v-toolbar>

              <v-divider></v-divider>

              <v-card-text>
                <h5 class="primary--text">¡Bienvenido!</h5>
                <p>Me llamo Jose Ángel y soy Ingeniero en Geomática y Topografía.</p>
                <p>Gracias a mi formación soy experto en diversas materias como: Geodesia, SIG, IDEs, Web Mapping...</p>
                <p>Me apasiona la programación y aprendo cada día de las nuevas tecnologías.</p>

                <v-divider></v-divider>

                <v-layout row>
                  <v-flex xs12 class="text-xs-center">
                    <v-btn icon href="https://github.com/joseahr" target="_blank">
                      <i class="fa fa-github fa-2x"></i>
                    </v-btn>
                    <v-btn icon href="https://stackoverflow.com/users/3866134/jose-hermosilla-rodrigo?tab=profile" target="_blank">
                      <i class="fa fa-stack-overflow fa-2x"></i>
                    </v-btn>
                    <v-btn icon href="https://www.facebook.com/jose.hermosillarodrigo" target="_blank">
                      <i class="fa fa-facebook fa-2x"></i>
                    </v-btn>
                    <v-btn icon href="https://www.instagram.com/josehermosillarodrigo/" target="_blank">
                      <i class="fa fa-instagram fa-2x"></i>
                    </v-btn>
                    <v-btn icon href="https://www.linkedin.com/in/jose-%C3%A1ngel-hermosilla-rodrigo-70a590147/" target="_blank">
                      <i class="fa fa-linkedin fa-2x"></i>
                    </v-btn>
                  </v-flex>
                </v-layout>

                <v-divider></v-divider>

              </v-card-text>

              <v-card-actions>
                <v-layout row wrap text-xs-center>
                  <v-flex xs12 sm6 class="pa-2">
                    <v-btn block primary to="/index/profile">Saber Más</v-btn>
                  </v-flex>
                  <v-flex xs12 sm6 class="pa-2">
                    <v-btn block primary to="/index/portfolio">Trabajos</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>

            </v-card>

          </v-scale-transition>
        </v-flex>
      </v-layout>
      <v-card-actions class="pa-0" style="margin-top: 10px;">
        <v-layout row>
          <v-flex xs12>
            <v-footer>
              <div>© {{ new Date().getFullYear() }}</div>
            </v-footer>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-app>
</template>


<style>
.card--flex-toolbar {
  margin-top: -64px;
}

.particles-js-canvas-el{
  position: absolute !important;
  top: 0;
}

#banner-welcome::before {
    content: " ";
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    background: linear-gradient( 45deg, rgba(255,0,0, 0.2), rgba(0,0,255,0.2) );
}
</style>

<script>
/* eslint-disable */
import 'particles.js'
//const particles = new Particles
const particles = window.particlesJS
const log = console.log;
export default {
  data() {
    return {
      toolbarVisible: false,
      parallaxHeight: 500
    };
  },
  methods: {
    onScroll() {
      const offsetTop =
        window.pageYOffset || document.documentElement.scrollTop;
      this.toolbarVisible = offsetTop > 0;
    }
  },
  created() {
    particles.load('banner-welcome', 'static/particles.json', ()=> console.log('loaded'));
  }
};
</script>




// WEBPACK FOOTER //
// Main.vue?f2349476